module.exports = __webpack_public_path__ + "img/8.16541b5a.jpg";